module.exports = __webpack_public_path__ + "8f3c27a40a3611a2826a8f179294c8db.svg";